module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.formReset) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "plssComponent",
      "id": 'plssComponentForm' + _vm.id
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.showTitle) ? _c('h4', [_vm._v("Add PLSS Locations")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Meridian")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.plssData.MeridianId),
      expression: "plssData.MeridianId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Meridian"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.plssData, "MeridianId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a Meridian")]), _vm._v(" "), _vm._l((_vm.meridianList), function(meridian) {
    return _c('option', {
      key: meridian.meridianId,
      domProps: {
        "value": meridian.meridianId
      }
    }, [_vm._v("\n                        " + _vm._s(meridian.description) + "\n                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plssComponent.Meridian')),
      expression: "errors.has('plssComponent.Meridian')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Meridian is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Township")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssData.Township),
      expression: "plssData.Township"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        validSection: [_vm.plssData.MeridianId, 'township']
      }),
      expression: "{required: true, validSection: [plssData.MeridianId, 'township']}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Township",
      "type": "text",
      "data-vv-delay": "1000",
      "placeholder": "Township",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.plssData.Township)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plssData, "Township", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plssComponent.Township')),
      expression: "errors.has('plssComponent.Township')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('plssComponent.Township')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Township Direction")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssData.TownshipDirection),
      expression: "plssData.TownshipDirection"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        validPlssDirection: [_vm.plssData.MeridianId, 'township']
      }),
      expression: "{required: true, validPlssDirection: [plssData.MeridianId, 'township']}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "TownshipDirection",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.plssData, "TownshipDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("N")]), _vm._v(" "), (_vm.plssData.MeridianId !== 1) ? _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("S")]) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plssComponent.TownshipDirection')),
      expression: "errors.has('plssComponent.TownshipDirection')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Township Direction is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Range")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssData.Range),
      expression: "plssData.Range"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        validSection: [_vm.plssData.MeridianId, 'range']
      }),
      expression: "{required: true, validSection: [plssData.MeridianId, 'range']}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "range",
      "type": "text",
      "data-vv-delay": "1000",
      "placeholder": "range",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.plssData.Range)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plssData, "Range", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plssComponent.range')),
      expression: "errors.has('plssComponent.range')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('plssComponent.range')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Range Direction")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssData.RangeDirection),
      expression: "plssData.RangeDirection"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        validPlssDirection: [_vm.plssData.MeridianId, 'range']
      }),
      expression: "{required: true, validPlssDirection: [plssData.MeridianId, 'range']}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "RangeDirection",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.plssData, "RangeDirection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), (_vm.plssData.MeridianId !== 1) ? _c('option', {
    attrs: {
      "value": "E"
    }
  }, [_vm._v("E")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "W"
    }
  }, [_vm._v("W")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('plssComponent.RangeDirection')),
      expression: "errors.has('plssComponent.RangeDirection')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Range Direction is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Sections")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("06")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_6"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[5],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[5]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[5],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("05")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_5"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[4],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[4]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[4],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("04")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_4"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[3],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[3]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[3],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("03")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_3"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[2],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[2]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[2],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("02")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_2"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[1],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[1]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[1],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("01")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    staticClass: "sectionCheckbox",
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_1"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[0],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[0]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[0],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("07")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_7"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[6],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[6]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[6],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("08")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_8"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[7],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[7]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[7],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("09")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_9"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[8],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[8]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[8],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("10")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_10"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[9],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[9]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[9],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("11")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_11"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[10],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[10]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[10],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("12")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_12"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[11],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[11]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[11],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("18")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_18"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[17],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[17]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[17],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("17")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_17"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[16],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[16]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[16],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("16")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_16"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[15],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[15]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[15],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("15")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_15"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[14],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[14]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[14],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("14")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_14"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[13],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[13]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[13],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("13")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_13"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[12],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[12]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[12],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("19")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_19"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[18],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[18]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[18],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("20")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_20"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[19],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[19]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[19],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("21")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_21"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[20],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[20]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[20],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("22")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_22"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[21],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[21]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[21],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("23")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_23"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[22],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[22]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[22],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("24")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_24"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[23],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[23]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[23],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("30")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_30"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[29],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[29]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[29],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("29")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_29"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[28],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[28]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[28],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("28")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_28"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[27],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[27]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[27],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("27")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_27"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[26],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[26]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[26],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("26")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_26"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[25],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[25]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[25],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("25")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_25"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[24],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[24]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[24],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sectionRow"
  }, [_c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("31")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_31"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[30],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[30]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[30],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("32")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_32"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[31],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[31]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[31],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("33")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_33"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[32],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[32]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[32],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("34")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_34"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[33],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[33]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[33],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("35")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_35"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[34],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[34]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[34],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sectionCheckboxLabel"
  }, [_vm._v("36")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plssSectionList),
      expression: "plssSectionList"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkBoxSection_36"
    },
    domProps: {
      "value": _vm.plssSectionLookupList[35],
      "checked": Array.isArray(_vm.plssSectionList) ? _vm._i(_vm.plssSectionList, _vm.plssSectionLookupList[35]) > -1 : (_vm.plssSectionList)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plssSectionList,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.plssSectionLookupList[35],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.plssSectionList = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.plssSectionList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.plssSectionList = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSaveBtn),
      expression: "showSaveBtn"
    }],
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "saveBtn",
      "disabled": _vm.disableSaveBtn
    },
    on: {
      "click": _vm.savePlss
    }
  }, [_vm._v("Add PLSS")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "clearBtn"
    },
    on: {
      "click": _vm.clearPlssInput
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Validation errors: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.errors))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("plssData: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.plssData))])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("plssSectionList: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.plssSectionList))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02301d2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlssComponent.vue
// module id = 883
// module chunks = 1